<div class="table tablewitharrows">
  <div class="blockheader">{{'Domains'|translate}}</div>
  <table fixedcols="[0, 4, 5]">
    <tr>
      <th></th>
      <th>{{'Settings' | translate}}</th>
      <th>{{'Links' | translate}}</th>
      <th class="th_width">{{'Outer logo'|translate }}</th>
      <th class="th_width">{{'Inner logo'|translate }}</th>
      <th class="th_width">{{'Favicon'|translate }}</th>
      <th><button class="btn_img btn_graygray btn_plusorange" (click)="addItem(this.model.domains)"></button></th>
    </tr>
    <!-- line doest exist -->
    <tr *ngFor="let domain of model.domains" app-domain-settings [domain]="domain" [domains]="model.domains">
    </tr>
  </table>

  <div class="blockheader">{{'Map layers'|translate}}</div>
  <table fixedcols="[0, 6, 7]">
    <tr>
      <th></th>
      <th>{{'Name'|translate }}</th>
      <th>{{'Provider'|translate }}</th>
      <th>{{'Source'|translate }}</th>
      <th>{{'Key'|translate }}</th>
      <th class="small_column">{{'Base layer'|translate }}</th>
      <th><button class="btn_img btn_graygray btn_plusorange" (click)="addItem(this.model.maplayers)"></button></th>
    </tr>
    <tr *ngFor="let layer of model.maplayers">
      <td>
        <button (click)="pullUp(layer, model.maplayers)" class="btn_img btn_graygray btn_up"></button>
        <button (click)="pullDown(layer, model.maplayers)" class="btn_img btn_graygray btn_down"></button>
      </td>
      <td><input type="text" [(ngModel)]="layer.Name" /></td>
      <td>
        <select class="singleselect" [(ngModel)]="layer.Provider">
          <option value="Baidu">Baidu</option>
          <option value="Bing">Bing</option>
          <option value="Google">Google</option>
          <option value="OSM">OSM</option>
          <option value="Yandex">Yandex</option>
          <option value="WMS">WMS</option>
        </select>
      </td>
      <td><input type="text" [(ngModel)]="layer.URL"/></td>
      <td><input type="text" [(ngModel)]="layer.Key"/></td>
      <td><input type="checkbox" [(ngModel)]="layer.IsBased"/></td>
      <td>
        <button class="btn_img btn_trush" (click)="deleteItem(layer, model.maplayers)" data-toggle="tooltip" data-placement="top" title="{{'Delete'|translate}}"></button>
      </td>
    </tr>
  </table>

  <div class="blockheader">{{'Geocoders'|translate}}</div>
  <table fixedcols="[0, 3, 4]">
    <tr>
      <th></th>
      <th>{{'Name'|translate }}</th>
      <th>{{'Provider'|translate }}</th>
      <th>{{'Url'|translate }}</th>
      <th>{{'Key'|translate }}</th>
      <th><button class="btn_img btn_graygray btn_plusorange" (click)="addItem(this.model.geocoders)"></button></th>
    </tr>
    <tr *ngFor="let geocoder of model.geocoders">
      <td>
        <button (click)="pullUp(geocoder, model.geocoders)" class="btn_img btn_graygray btn_up"></button>
        <button (click)="pullDown(geocoder, model.geocoders)" class="btn_img btn_graygray btn_down"></button>
      </td>
      <td><input type="text" [(ngModel)]="geocoder.Name" /></td>
      <td>
        <select class="singleselect" [(ngModel)]="geocoder.Provider">
          <option value="Baidu">Baidu</option>
          <option value="Bing">Bing</option>
          <option value="Dadata">Dadata</option>
          <option value="GoMap">GoMap.az</option>
          <option value="Google">Google</option>
          <option value="Nominatim">Nominatim</option>
          <option value="Yandex">Yandex</option>
        </select>
      </td>
      <td><input type="text" [(ngModel)]="geocoder.Url" /></td>
      <td><input type="text" [(ngModel)]="geocoder.Key" /></td>
      <td>
        <button class="btn_img btn_trush" (click)="deleteItem(geocoder, model.geocoders)" data-toggle="tooltip" data-placement="top" title="{{'Delete'|translate}}"></button>
      </td>
    </tr>
  </table>
</div>
